import { render, staticRenderFns } from "./TaxTracker.vue?vue&type=template&id=71066ac1&scoped=true&"
import script from "./TaxTracker.vue?vue&type=script&lang=js&"
export * from "./TaxTracker.vue?vue&type=script&lang=js&"
import style0 from "./TaxTracker.vue?vue&type=style&index=0&id=71066ac1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71066ac1",
  null
  
)

export default component.exports